import { render, staticRenderFns } from "./addMenuView.vue?vue&type=template&id=cc0dfe28&scoped=true"
import script from "./addMenuView.vue?vue&type=script&lang=js"
export * from "./addMenuView.vue?vue&type=script&lang=js"
import style0 from "./addMenuView.vue?vue&type=style&index=0&id=cc0dfe28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc0dfe28",
  null
  
)

export default component.exports